module.exports={
  "Description": "GB",
  "RedundantCharacters": " -",
  "ValidationRegex": "((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[0-9][A-Za-z]{2})|GIR0AA",
  "ValidationRegex.DOC": "https://www.gov.uk/government/uploads/system/uploads/attachment_data/file/488478/Bulk_Data_Transfer_-_additional_validation_valid_from_12_November_2015.pdf",
  "TestData": {
    "Valid": [
      "CW3 9SS",
      "SE5 0EG",
      "SE50EG",
      "WC2H 7LT",
      "se5 0eg",
      "Z29ZZ",
      "Z699ZZ",
      "ZX99ZZ",
      "ZC999ZZ",
      "EC1A 1BB",
      "W1A 0AX",
      "M1 1AE",
      "B33 8TH",
      "CR2 6XH",
      "DN55 1PT",
      "GIR 0AA",
      "W1U 1BW",
      "SK8 7NA"
    ],
    "Invalid": [
      "WC2H 7LTa",
      "WC2H"
    ]
  }
}